export default __webpack_public_path__ + "static/media/bp11.f79b3c35.png";